module.exports = __webpack_public_path__ + "img/placemat-batten.1e34a613.jpg";